<template>
  <w-icon-wrapper
    :height="23.733"
    :width="24.018"
    view-box="0 0 23.733 24.018"
    icon-name="work-reserved-icon"
  >
    <g
      id="_92_Bestellt"
      data-name="92 Bestellt"
      transform="translate(29.356 -0.426)"
    >
      <g
        id="Gruppe_25622"
        data-name="Gruppe 25622"
      >
        <path
          id="Pfad_55846"
          data-name="Pfad 55846"
          d="M-29.054,9.782A12.018,12.018,0,0,1-14.7.724a12.162,12.162,0,0,1,1.8.557,11.849,11.849,0,0,1,3.924,2.57V1.914a1,1,0,0,1,1-1,1,1,0,0,1,1,1v5.2h-5.2a1,1,0,0,1-1-1,1,1,0,0,1,1-1h1.629a9.874,9.874,0,0,0-3.091-1.975,10.266,10.266,0,0,0-1.5-.465A10.016,10.016,0,0,0-27.1,10.224a9.94,9.94,0,0,0,1.293,7.548,9.939,9.939,0,0,0,6.249,4.421,9.933,9.933,0,0,0,7.544-1.3A9.946,9.946,0,0,0-7.6,14.643a1,1,0,0,1,1.2-.754,1,1,0,0,1,.754,1.2,11.931,11.931,0,0,1-5.3,7.5,11.925,11.925,0,0,1-6.38,1.855,12.121,12.121,0,0,1-2.674-.3,11.919,11.919,0,0,1-7.5-5.305A11.93,11.93,0,0,1-29.054,9.782Z"
          fill="currentColor"
        />
      </g>
      <g
        id="Gruppe_25623"
        data-name="Gruppe 25623"
      >
        <path
          id="Pfad_55847"
          data-name="Pfad 55847"
          d="M-10.525,17.994V14.2h-13.93v3.79h1.93V16.2h4.02v1.79h1.93V16.2h4.12v1.79Z"
          fill="currentColor"
        />
        <rect
          id="Rechteck_4049"
          data-name="Rechteck 4049"
          width="6"
          height="6"
          transform="translate(-19.49 6.876)"
          fill="currentColor"
        />
        <rect
          id="Rechteck_4050"
          data-name="Rechteck 4050"
          width="3.765"
          height="3.765"
          transform="translate(-24.49 9.112)"
          fill="currentColor"
        />
        <rect
          id="Rechteck_4051"
          data-name="Rechteck 4051"
          width="2.006"
          height="2.006"
          transform="translate(-12.494 10.87)"
          fill="currentColor"
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconReserved' };
</script>
